import * as React from 'react';
import { useItemTypeLevelsQuery } from '@/common/queries/useItemTypeLevelsQuery';
import { useItemTypesByIdQuery } from '@/common/queries/useItemTypesQuery';

/**
 * True when `itemTypeId` sits at the deepest item-type level for the org — i.e.
 * it can never have children, so a "rolls up from descendants" figure for it
 * is always trivially equal to its own self value.
 */
export const useIsLowestItemTypeLevel = (itemTypeId: number | undefined): boolean => {
  const { data: itemTypeLevels } = useItemTypeLevelsQuery();
  const { data: itemTypesById } = useItemTypesByIdQuery();

  return React.useMemo(() => {
    if (itemTypeId === undefined || !itemTypeLevels?.length) return false;
    const maxLevel = Math.max(...itemTypeLevels.map((l) => l.level));
    const itemType = itemTypesById?.[itemTypeId];
    if (!itemType) return false;
    const level = itemTypeLevels.find((l) => l.id === itemType.itemLevelId);
    return level?.level === maxLevel;
  }, [itemTypeId, itemTypeLevels, itemTypesById]);
};
